module.exports = __webpack_public_path__ + "img/music.47604545.jpg";